import { useMutation } from '@tanstack/react-query'
import { jsonFetch } from '@/lib/api/jsonFetch'
import type { BolRequest, BolResponse } from './types'

const ROOT = '/api/bol'

export function useGenerateBol() {
  return useMutation({
    mutationFn: (body: BolRequest) =>
      jsonFetch<BolResponse>(`${ROOT}/generate`, { method: 'POST', body }),
  })
}
